export const prepareData = (data: any) => {
    if (Array.isArray(data)) {
        const out: any[] = data.map((x: any) => {
            if (x !== undefined) {
                if (typeof(x) === 'object' && x !== null) {
                    return prepareData(x)
                } else {
                    return x
                }
            } else {
                return null
            }
        })

        return out
    } else {
        const out: any = {}
        Object.keys(data).forEach((k: string) => {
            if (data[k] !== undefined) {
                if (typeof(data[k]) === 'object' && data[k] !== null) {
                    out[k] = prepareData(data[k])
                } else {
                    out[k] = data[k]
                }
            } else {
                out[k] = null
            }
        })

        return out
    }
}
